import { api } from './client.js';

export interface RefreshCookiesResult {
  ok: true;
  cookieCount: number;
  savedAt: string;
}

export interface CookiesStatus {
  updatedAt: string | null;
  daysAgo: number | null;
}

export async function refreshCookies(chromeExport: string): Promise<RefreshCookiesResult> {
  return api<RefreshCookiesResult>('/carrefour/cookies', {
    method: 'POST',
    body: JSON.stringify({ chromeExport }),
  });
}

export async function getCookiesStatus(): Promise<CookiesStatus> {
  return api<CookiesStatus>('/carrefour/cookies/status');
}

export interface ScraperJwtStatus {
  issuedAt: string | null;
  daysUntilExpiry: number | null;
}

export interface RegenerateScraperJwtResult {
  ok: true;
  issuedAt: string;
  expiresAt: string;
}

export async function getScraperJwtStatus(): Promise<ScraperJwtStatus> {
  return api<ScraperJwtStatus>('/carrefour/scraper-jwt/status');
}

export async function regenerateScraperJwt(): Promise<RegenerateScraperJwtResult> {
  return api<RegenerateScraperJwtResult>('/carrefour/scraper-jwt/regenerate', {
    method: 'POST',
  });
}

export interface TriggerRunResult {
  ok: true;
  store: ScraperStore;
  triggeredAt: string;
}

/** Les deux scrapers. La route nomme son magasin depuis l'ADR 0012 § 5 : il n'y a plus
 * de `/carrefour/trigger`, et un bundle resté en cache prendra un 404 explicite. */
export type ScraperStore = 'carrefour' | 'lafourche';

export async function triggerScraperRun(store: ScraperStore): Promise<TriggerRunResult> {
  return api<TriggerRunResult>(`/scraper/${store}/trigger`, { method: 'POST' });
}

export interface LafourcheCredentialsStatus {
  refreshTokenUpdatedAt: string | null;
  cartIdUpdatedAt: string | null;
}

export interface SaveLafourcheResult {
  ok: true;
  savedAt: string;
  refreshToken: boolean;
  cartId: boolean;
}

export async function getLafourcheStatus(): Promise<LafourcheCredentialsStatus> {
  return api<LafourcheCredentialsStatus>('/lafourche/credentials/status');
}

export async function saveLafourcheCredentials(input: {
  refreshToken?: string;
  cartId?: string;
}): Promise<SaveLafourcheResult> {
  return api<SaveLafourcheResult>('/lafourche/credentials', {
    method: 'POST',
    body: JSON.stringify(input),
  });
}
